import React from 'react'
import { messageWidth, templateImgStyle } from './config'
import classNames from 'classnames'
import { uid } from 'react-uid'
import { TemplateImg } from './TemplateImg'
import Button from '../Button'
import { generatePostBackObject } from '../../../../actions/static'
import TemplateText from './TemplateText'
import classes from './styles.module.scss'

const TemplateSlidesList = ({
  slides,
  isRtl,
  device,
  settings,
  openIframe,
  refTemplateList,
  postMessage,
}) => {
  return (
    <>
      {slides &&
        slides.map((element, index) => {
          return (
            <div
              style={{
                ...messageWidth(device.width - 46),
                position: 'relative',
              }}
              className={classNames('generic_template', 'full-screen-message')}
              key={uid(element)}
              ref={node => (refTemplateList[index] = node)}>
              {element.defaultAction && element.defaultAction.webUrl && (
                <a
                  target="_blank"
                  href={element.element.defaultAction.webUrl}
                  rel="noreferrer">
                  <TemplateImg
                    url={element.imageUrl}
                    classesWithTitle={classes.templateImg}
                    classesWithOutTitle={classes.templateImgWithoutTitle}
                    styles={templateImgStyle(device.width)}
                    title={element.title || element.subtitle}
                  />
                </a>
              )}

              {element.defaultAction &&
                !element.defaultAction.webUrl &&
                element.defaultAction.type === 'web_url' && (
                <TemplateImg
                  url={element.imageUrl}
                  classes={classes.templateImg}
                  styles={templateImgStyle(device.width)}
                />
              )}
              {!element.defaultAction && (
                <TemplateImg
                  url={element.imageUrl}
                  classesWithTitle={classes.templateImg}
                  classesWithOutTitle={classes.templateImgWithoutTitle}
                  styles={templateImgStyle(device.width)}
                  title={element.title || element.subtitle}
                />
              )}

              <TemplateText
                device={device}
                isRtl={isRtl}
                title={element.title}
                subtitle={element.subtitle}
              />

              <div style={messageWidth(device.width - 46)}>
                {element.buttons != null &&
                  element.buttons.map(button => (
                    <Button
                      button={button}
                      key={uid(button)}
                      title={button.title}
                      style={{ color: settings.color }}
                      openIframe={openIframe}
                      onClick={() =>
                        postMessage(generatePostBackObject(button))
                      }
                    />
                  ))}
              </div>
            </div>
          )
        })}
    </>
  )
}

export default TemplateSlidesList
